import { Button, Typography } from '@material-ui/core';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import React from 'react';
import {
  DownloadOpts,
  usePrintOrDownload,
} from '../../hooks/usePrintOrDownload';
import { useTranslation } from '../../hooks/useTranslation';

export const Download = (opts: DownloadOpts) => {
  const { handleDownload } = usePrintOrDownload(opts);
  const { t } = useTranslation();

  return (
    <Button
      data-print-exclude
      color="primary"
      onClick={handleDownload}
      endIcon={<SystemUpdateAltIcon />}
    >
      <Typography>{t('DOWNLOAD')}</Typography>
    </Button>
  );
};
